exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/vietnam-map/vietnam-map.component.scss
// module id = ../../../../../src/app/_custom/vietnam-map/vietnam-map.component.scss
// module chunks = main